import { useEffect, useState } from "react";
import { getSettings } from "../api";

const DEFAULTS = {
  email: "info@photonpe.com",
  phone: "+91 9311914818",
  address: "3rd Floor, B-53, Sector 64, Noida, Gautam Buddha Nagar, Uttar Pradesh – 201301",
};

let cache = null;
let inflight = null;

const load = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = getSettings()
      .then((data) => {
        cache = { ...DEFAULTS, ...data };
        return cache;
      })
      .catch(() => DEFAULTS)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export default function useSettings() {
  const [settings, setSettings] = useState(cache || DEFAULTS);
  useEffect(() => {
    let mounted = true;
    load().then((s) => mounted && setSettings(s));
    return () => {
      mounted = false;
    };
  }, []);
  const phoneRaw = (settings.phone || "").replace(/[^\d+]/g, "");
  return { ...settings, phoneRaw };
}
